import { cn } from "../../lib/utils";
import { MdChatBubble, MdClose, MdFullscreen, MdDrafts, MdMail, MdList } from "react-icons/md";

interface MessageDropdownProps {
    isOpen: boolean;
    onClose: () => void;
    unreadCount?: number;
}

export function MessageDropdown({ isOpen, onClose, unreadCount = 0 }: MessageDropdownProps) {
    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/5 z-40 transition-opacity messages-backdrop"
                onClick={onClose}
            />

            {/* Dropdown Container */}
            <div className="fixed top-0 right-0 h-screen w-full sm:w-[500px] bg-[hsl(var(--card))] shadow-[-8px_0_32px_rgba(0,0,0,0.1)] z-50 flex flex-col transform transition-transform duration-300 animate-in slide-in-from-right messages-drawer">

                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 bg-[hsl(var(--muted))] border-b border-[hsl(var(--border))] shrink-0">
                    <div className="flex items-center gap-2">
                        <MdChatBubble className="w-5 h-5 text-[hsl(var(--foreground))]" />
                        <h3 className="text-[15px] font-bold text-[hsl(var(--foreground))]">Latest Messages</h3>
                        <span className="text-[11px] text-[hsl(var(--muted-foreground))] font-medium whitespace-nowrap">(* last 60d)</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                        <button className="p-1.5 text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--secondary))] rounded transition-colors" title="Expand">
                            <MdFullscreen className="w-5 h-5" />
                        </button>
                        <button onClick={onClose} className="p-1.5 text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--secondary))] rounded transition-colors" title="Close">
                            <MdClose className="w-5 h-5" />
                        </button>
                    </div>
                </div>

                {/* Filters */}
                <div className="flex items-center gap-2 px-4 py-2 border-b border-[hsl(var(--border))] overflow-x-auto scrollbar-hide shrink-0 bg-[hsl(var(--card))]">
                    <button className="flex items-center gap-2 px-3 py-1.5 bg-[hsl(var(--muted))] border border-[hsl(var(--border))] rounded text-sm font-semibold text-[hsl(var(--foreground))] hover:bg-[hsl(var(--secondary))] transition-colors shrink-0">
                        <MdMail className="w-3.5 h-3.5 text-[hsl(var(--muted-foreground))]" />
                        Unread ({unreadCount})
                    </button>
                    <button className="flex items-center gap-2 px-3 py-1.5 bg-[hsl(var(--card))] border border-transparent rounded text-sm font-medium text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--secondary))] transition-colors shrink-0">
                        <MdDrafts className="w-3.5 h-3.5 text-[hsl(var(--muted-foreground))]" />
                        Read
                    </button>
                    <button className="flex items-center gap-2 px-3 py-1.5 bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded text-sm font-medium text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--secondary))] transition-colors shrink-0">
                        <MdList className="w-3.5 h-3.5 text-[hsl(var(--muted-foreground))]" />
                        Show all
                    </button>
                </div>

                {/* Content Area */}
                <div className="flex-1 overflow-y-auto bg-[hsl(var(--card))] relative">
                    <div className="flex flex-col items-center justify-center h-full p-8 text-center text-[hsl(var(--muted-foreground))]">
                        <div className="w-16 h-16 rounded-full bg-[hsl(var(--muted))] flex items-center justify-center mb-4 border border-[hsl(var(--border))]">
                            <MdChatBubble className="w-8 h-8 text-[hsl(var(--muted-foreground))]" />
                        </div>
                        <p className="font-medium text-[hsl(var(--foreground))]">No messages found!</p>
                        <p className="text-sm mt-1 text-[hsl(var(--muted-foreground))]">Select a filter or check back later.</p>
                    </div>
                </div>

                {/* Footer */}
                <div className="grid grid-cols-2 border-t border-[hsl(var(--border))] bg-[hsl(var(--card))] shrink-0">
                    <button
                        onClick={onClose}
                        className="py-4 text-[13px] font-semibold text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--secondary))] hover:text-[hsl(var(--foreground))] transition-colors flex justify-center items-center border-r border-[hsl(var(--border))]"
                    >
                        Close
                    </button>
                    <button
                        className="py-4 text-[13px] font-bold text-[#0088cc] hover:bg-[#0088cc]/10 transition-colors flex justify-center items-center gap-2 disabled:opacity-50"
                    >
                        <span className="w-4 h-4 flex items-center justify-center rounded-full border border-current text-[10px]">✓</span>
                        Mark all as read
                    </button>
                </div>
            </div>
        </>
    );
}

